import {
  Box,
  Button,
  DialogActions,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { ModalHeader } from "../../common/modalHeader";
import EventIcon from "@mui/icons-material/Event";
// import { DateCp } from "./dateCp";
// import { addCounter, updateCounter } from "./api";
import { getAllGroup } from "../customerGrouping/customerGroupingApi";
import Swal from "sweetalert2";
import { swalAlertPopProps } from "../../utils/commonUtils";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { DateCp } from "../customerDetail/dateCp";
import { addCounter } from "../customerDetail/api";
import { updateUser } from "./companyLoginApiHandler";
export const UserForm = ({
  open,
  setOpen,
  modalData,
  setModalData,
  callback,
  fetchUsers,
}) => {
  let t = {
    customer: "",
    customerMobile: "",
    mPin: "",
    anniversaryDate: new Date(),
    customerMailID: "",
    gender: "",
    customerGroup: "",
  };
  const validateData = (data) => {
    if (!data.name || data.name.trim() === "") {
      return { status: false, message: " name is required." };
    }
    if (!data.mobileNumber || data.mobileNumber.trim() === "") {
      return { status: false, message: "number is required." };
    }
    if (!data.mPin || data.mPin.trim() === "") {
      return { status: false, message: "mPin is required." };
    }
    return { status: true };
  };
  const [formData, setFormData] = useState({ ...t });
  const [allGroups, setAllGroups] = useState([]);

  const handleClose = () => {
    setOpen(false);
    // setModalData(null);
    // setFormData({
    //   customer: "",
    //   customerMobile: "",
    //   birthdate: null,
    //   anniversaryDate: null,
    //   customerMailID: "",
    //   gender: "",
    //   customerGroup: "",
    // });
  };

  // useEffect(() => {
  //   getAllGroup((data) => {
  //     setAllGroups(data?.data?.list);
  //   });
  // }, []);

useEffect(() => {
  if (modalData) {
    setFormData({
      ...modalData,
      name: modalData.name || "",
      mobileNumber: modalData.mobileNumber || "",
      mPin: modalData.mPin || "",
      role: modalData.role || "",
    });
    setOpen(true); // open only after formData is ready
  }
}, [modalData]);



  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            background: "white",
            width: { xs: "95%", sm: "85%", md: "70%", lg: "38%", xl: "38%" },

            overflowY: "auto",
            borderRadius: "10px",
            position: "absolute",
            left: { xs: "2%", sm: "5%", md: "10%", lg: "31%", xl: "31%" },

            top: "13%",
          }}
        >
          <ModalHeader title={"Edit User Profile"} onClose={handleClose} />
          <Divider />
          <Box sx={{ paddingX: "20px" }}>
            <Grid container sx={{ position: "relative" }}>
              <Grid item xs={12}>
                <Box sx={{ mt: 2 }}>
                  <TextField
                    fullWidth
                    id="briefAddress"
                    size="small"
                    label={
                      <span>
                        User Name: <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    InputProps={{
                      sx: {
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },

                        // height: '40px',
                        // background:"yellow"
                      },
                    }}
                    value={formData?.name}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        name: e.target.value,
                      });
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ mt: 2 }}>
                  <TextField
                    fullWidth
                    id="briefAddress"
                    size="small"
                    // label="Mobile Number:"
                    label={
                      <span>
                        Mobile Number : <span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{
                      sx: {
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        // height: '40px',
                        // background:"yellow"
                      },
                    }}
                    value={formData?.mobileNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        setFormData({
                          ...formData,
                          mobileNumber: value,
                        });
                      }
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ mt: 2 }}>
                  <TextField
                    fullWidth
                    id="briefAddress"
                    size="small"
                    label="MPIN:"
                    InputProps={{
                      sx: {
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        // height: '40px',
                        // background:"yellow"
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    value={formData?.mPin}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        mPin: e.target.value,
                      });
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sx={{ mt: 2 }}>
                <FormControl
                  sx={{ width: "100%", position: "relative", height: "50px" }}
                >
                  <InputLabel
                    id="customer-group-select-label"
                    sx={{ position: "absolute", top: "0", height: "50px" }}
                  >
                    Role
                  </InputLabel>
                  <Select
                    labelId="customer-group-select-label"
                    id="customer-group-select"
                    value={formData.role}
                    sx={{
                      height: "50px",
                      backgroundColor: "white",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      display: "flex",
                      alignItems: "center",
                    }}
                    label="Role"
                    IconComponent={() => (
                      <KeyboardArrowDownIcon
                        sx={{ fontSize: "30px", color: "primary.main" }}
                      />
                    )}
                    onChange={(e) =>
                      setFormData({ ...formData, role: e.target.value })
                    }
                  >
                    <MenuItem
                      sx={{
                        fontWeight: 500,
                        color: "#01008B",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                      value="User"
                    >
                      User
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontWeight: 500,
                        color: "#01008B",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                      value="Admin"
                    >
                      Admin
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontWeight: 500,
                        color: "#01008B",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                      value="Sub-Admin"
                    >
                      Sub-Admin
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },

                        color: "#01008B",
                      }}
                      value="Support"
                    >
                      Support
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              padding: "15px 10px",
            }}
          >
            <Button
              variant="contained"
              sx={{
                width: "50%",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
              // onClick={() => {
              //   if (modalData) {
              //     let valid = validateData(formData);
              //     if (valid.status) {
              //       updateUser({ ...formData }, () => {
              //         // callback();
              //         setModalData(null);
              //         handleClose();
              //         fetchUsers();
              //       });
              //       setOpen(false);
              //     } else {
              //       Swal.fire({
              //         icon: "error",
              //         title: valid.message,
              //         ...swalAlertPopProps,
              //       });
              //     }

              //   }
              // }}
              onClick={async () => {
                if (modalData) {
                  const valid = validateData(formData);
                  if (valid.status) {
                    try {
                      await updateUser({ ...formData }); // wait for update to complete
                      await fetchUsers(); // now this will show the updated list
                      setModalData(null);
                      handleClose();
                    } catch (err) {
                      console.error("Error updating user", err);
                      Swal.fire({
                        icon: "error",
                        title: "Update Failed",
                        text:
                          err?.response?.data?.message ||
                          "Something went wrong!",
                        ...swalAlertPopProps,
                      });
                    }
                  } else {
                    Swal.fire({
                      icon: "error",
                      title: valid.message,
                      ...swalAlertPopProps,
                    });
                  }
                }
              }}
            >
              {modalData ? "Update" : "Save"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
